import * as Realm from 'realm-web'

// Would be better built within a worker
export default class MongoDbDataCollectionService {
  constructor (appId) {
    this.app = new Realm.App({ id: appId })
  }

  async loginAsync () {
    // Create an anonymous credential
    const credentials = Realm.Credentials.anonymous()
    try {
      // Authenticate the user
      const user = await this.app.logIn(credentials)
      // `App.currentUser` updates to match the logged in user
      console.assert(user.id === this.app.currentUser.id)
      return user
    } catch (err) {
      console.error('Failed to log in', err)
    }
  }

  async logoutAsync () {
    try {
      if (this.app.currentUser) {
        await this.app.currentUser.logOut()
      }
    } catch (err) {
      console.error('Failed to log out', err)
    }
  }

  async startAsync (userType) {
    try {
      if ((!!this.app.currentUser && this.app.currentUser.isLoggedIn) === false) {
        await this.loginAsync()
      }

      var response = await this.app.currentUser.functions.startSession(
        userType
      )
      return response.userId
    } catch (err) {
      console.error('Failed to send data', err)
    }
  }

  async sendAsync (record, userId) {
    try {
      if ((!!this.app.currentUser && this.app.currentUser.isLoggedIn) === false) {
        await this.loginAsync()
      }

      var response = await this.app.currentUser.functions.recordData(
        record,
        userId
      )
      return response.userId
    } catch (err) {
      console.error('Failed to send data', err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/mongoDbDataCollectionService.js